import { paginationSize } from '../../../constants/constants';
import { FETCH_PARKED_VISITS, FETCH_PARKED_VISITS_ERROR, FETCH_PARKED_VISITS_START, FETCH_PARKED_VISITS_SUCCESS, SET_PARKED_VISITS_PAGINATION } from "../../actions/groupadmin/parkedActions";


const INIT_STATE = {
    parked: [],
    loading: false,
    message: '',
    error: '',
    pagination: {
        currentPage: 1,
        pageSize: paginationSize,
        totalPages: 0,
        totalItems: 0,
    },
    searchFilter: {
        searchText: "",
        risId: 1,
        mipIds: [],
        modalityIds: [],
    },
    sortConditions: [{ sortBy: "visitStart", dataType: "DATE", sortType: "desc" }]
}

export const parkedReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_PARKED_VISITS_START:
            return { ...state, error: '', message: '', loading: true }

        case FETCH_PARKED_VISITS_SUCCESS:
            return { ...state, error: '', message: '', loading: false, parked: action.parked.length > 0 ? [...action.parked] : [] }

        case SET_PARKED_VISITS_PAGINATION: {
            return { ...state, pagination: action.pagination };
        }

        case FETCH_PARKED_VISITS_ERROR:
            return { ...state, loading: false, error: '' }
        default:
            return state;
    }
}

export default parkedReducer;